import { environment } from './../../environments/environment.prod';
import { Injectable } from "@angular/core";
import { MessagesTitles } from "app/models/messages";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  defaultAlertConfig = {
    allowOutsideClick: true,
    heightAuto: false,
  };
  constructor(
    private msgTitulos: MessagesTitles,
  ) { }

  confirmAndDeleteWithValue(titleDetail?: string) {
    return Swal.fire({
      ... this.defaultAlertConfig,
      title:
        "¿Estas seguro de eliminar " +
        (titleDetail === undefined ? "este registro" : "los datos de " + titleDetail) +
        "?",
      text: "Esta acción no se podrá revertir.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "¡Sí, Eliminalo!",
      cancelButtonText: "No, cancelalo",
    });
  }

  deletedAlert(text?: string, title?: string) {
    text = text || "El registro ha sido eliminado.";
    title = title || this.msgTitulos.Deleted;
    return this.successAlert(text, title);
  }

  errorAlert(text?: string, title?: string) {
    return Swal.fire({
      ... this.defaultAlertConfig,
      title: title || this.msgTitulos.Error,
      text: text || "No se pudo ejecutar la operación",
      type: "error"
    });
  }

  successAlert(text?: string, title?: string) {
    return Swal.fire({
      ... this.defaultAlertConfig,
      title: title || this.msgTitulos.Success,
      text: text || "Operación realizada con éxito",
      type: "success"
    });
  }

  infoAlert(text?: string, title?: string) {
    return Swal.fire({
      ... this.defaultAlertConfig,
      title: title || this.msgTitulos.Info,
      text: text || "Información general",
      type: "info"
    });
  }

  warningAlert(text?: string, title?: string) {
    return Swal.fire({
      ... this.defaultAlertConfig,
      title: title || this.msgTitulos.Warning,
      text: text || "Existe una observación en la información",
      type: "warning"
    });
  }

  /**
   * Función para detectar y formatear los errores derivantes de algún service.
   * @param errorResponse Error desde service.
   * @param errorText Texto específico para este error.
   * @returns Texto o arreglo de textos formateados (válido para atributo "html" de Sweet Alert).
   */
  createTextError(errorResponse: any, errorText: string) {
    let text = errorText;
    let errores = [];

    if (errorResponse.code) {
      errores = errorResponse.error.error.error;
    } else {
      errores = errorResponse.error;
    }

    if (typeof errores == 'string') {
      text = ' - '.concat(errores);
    }

    if (typeof errores == 'object') {
      this.textFromObject(text, errores);
    }

    return text;
  }

  textFromObject(text: string, errores: Object) {
    let textFinal = text;
    for (let key in errores) {
      let value = errores[key];
      if (value.errorMessage) {
        textFinal = '- '.concat(value.errorMessage, '<br>');
        return textFinal;
      } else if (typeof value === 'object' && environment.production) {
        for (let key2 in value) {
          let value2 = value[key2];
          if (typeof value2 !== 'number') {
            textFinal += '- '.concat(value2, ' (', key2, ')<br>');
          }
        }
      }
    }
  }
}